import { render, staticRenderFns } from "./SocialSafetyForm.vue?vue&type=template&id=4702e593&scoped=true&"
import script from "./SocialSafetyForm.vue?vue&type=script&lang=js&"
export * from "./SocialSafetyForm.vue?vue&type=script&lang=js&"
import style0 from "./SocialSafetyForm.vue?vue&type=style&index=0&id=4702e593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4702e593",
  null
  
)

export default component.exports